function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#5768a8;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Icon-users");

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  id: "spacer",
  className: "cls-1",
  width: 32,
  height: 32
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "usersOutline",
  className: "cls-2 fill",
  d: "M30,30H28V27a3,3,0,0,0-3-3H21a3,3,0,0,0-3,3v3H16V27a5,5,0,0,1,5-5h4a5,5,0,0,1,5,5ZM23,12a3,3,0,1,1-3,3,3,3,0,0,1,3-3m0-2a5,5,0,1,0,5,5A5,5,0,0,0,23,10ZM16,22H14V19a3,3,0,0,0-3-3H7a3,3,0,0,0-3,3v3H2V19a5,5,0,0,1,5-5h4a5,5,0,0,1,5,5ZM9,4A3,3,0,1,1,6,7,3,3,0,0,1,9,4M9,2a5,5,0,1,0,5,5A5,5,0,0,0,9,2Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "usersFill",
  className: "cls-1",
  d: "M30,30H28V27a3,3,0,0,0-3-3H21a3,3,0,0,0-3,3v3H16V27a5,5,0,0,1,5-5h4a5,5,0,0,1,5,5ZM23,10a5,5,0,1,0,5,5A5,5,0,0,0,23,10ZM16,22H14V19a3,3,0,0,0-3-3H7a3,3,0,0,0-3,3v3H2V19a5,5,0,0,1,5-5h4a5,5,0,0,1,5,5ZM9,2a5,5,0,1,0,5,5A5,5,0,0,0,9,2Z"
});

var SvgUsers = function SvgUsers(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/users.3afc87ae.svg";
export { ForwardRef as ReactComponent };